import { Model } from "../../hooks/useFile";
import { Capitalize } from "../../utils/stringUtil";
import { cn } from "../../utils/style";
import { Icon, Icons } from "../Icon";

const ModelSelectBox = ({
  models,
  setHoveredModel,
  checked,
  setChecked,
  setModelIndex,
}: {
  models: Model[];
  selectedModelIndex: number;
  setSelectedModelIndex: (idx: number) => void;
  setHoveredModel: (idx: number | null) => void;
  hoveredModel: number | null;
  checked: number;
  setChecked: (idx: number) => void;
  setModelIndex: (idx: number) => void;
}) => {
  return (
    <div className="flex flex-1 flex-col gap-2">
      <div className="subtle text-muted-darker">Model</div>
      <div className="flex h-[50vh] overflow-hidden rounded-lg border bg-subtle">
        <div className="w-full overflow-y-scroll">
          <fieldset className="w-full">
            <div className="m-2 divide-y">
              {models.map((model, idx) => (
                <div
                  onClick={() => {
                    setModelIndex(idx);
                    setChecked(idx);
                  }}
                  onMouseEnter={() => {
                    setHoveredModel(idx);
                  }}
                  onMouseLeave={() => {
                    setHoveredModel(null);
                  }}
                  className={cn({
                    "subtle text-muted-darker": idx !== checked,
                    "subtle-semibold text-foreground": idx === checked,
                    "px-2": true,
                  })}
                  key={idx}
                >
                  <div
                    key={idx}
                    className="relative flex w-full cursor-pointer items-center"
                  >
                    <div className="w-full min-w-0 flex-1 py-1">
                      <label
                        htmlFor={`model-${idx}`}
                        className="cursor-pointer select-none"
                      >
                        {model.name}
                      </label>
                      {model.status?.toLowerCase() != "public" && (
                        <span
                          className={cn({
                            "detail ml-1.5 inline-flex items-center": true,
                            "text-accent-blue-foreground":
                              model.status?.toLowerCase() === "beta",
                            "text-accent-green":
                              model.status?.toLowerCase() !== "beta",
                          })}
                        >
                          {Capitalize(model.status)}
                        </span>
                      )}
                    </div>

                    <div
                      className={`my-1 flex h-6 items-center ${checked === idx ? "" : "invisible"}`}
                    >
                      <Icon source={Icons.Check} />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </fieldset>
        </div>
      </div>
    </div>
  );
};

export default ModelSelectBox;
